import { useParams } from 'react-router-dom';
import JitsiMeeting from '../components/videollamada/Jitsi.component';
import { getRoomName } from '../helpers/llamada.helper';
import { useTurnoDelPaciente } from '../data/hooks/useTurnos.hook';
import { Spinner } from '../components/spinner/Spinner.component';
import { TurnoStatus } from '../data/types/turnos.type';

export const VideoLlamadaApp = () => {
	const { turnoId } = useParams()
	const parsedTurnoId = turnoId ? Number(turnoId) : undefined
	const { data: turno, isPending } = useTurnoDelPaciente(parsedTurnoId)
	
	if (isPending) return <Spinner />
	if (!turno) return <div>Turno no encontrado</div>
	if (turno.statusTurno !== TurnoStatus.PENDIENTE) return <div>No se puede abrir la videollamada en este momento</div>

	return (
		<JitsiMeeting 
			roomName={getRoomName(turno.id, turno.medicoNombre, turno.pacienteNombre)} 
			displayName={turno.pacienteNombre} 
		/>
	)
}